// @ is an alias to /src
import DataHandlerService from "@/services/data";
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

const dataHandler = new DataHandlerService();
export default {
  name: "navi",
  props: ["authenticated"],
  components: { "popper": Popper },
  data() {
    return {
      user: dataHandler.getUserData(),
      popperOptions: {
        placement: 'top',
        modifiers: { offset: { offset: '20px,5px' } }
      }
    }
  }
};
